/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-empty-pattern */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */


import * as React from 'react';

/* APP / CONFIG / CONTEXT */

import {dateCoverter} from '../../AppConfig';
import { useAppContextoReact } from '../../servicos/app/AppContextoReact';
import OptionsController from '../../servicos/forms/OptionsController';

/* INTERFACES / ENUM */

import {IPropsTableListaPaginada, ColumnTypes, ETABLE, Order} from './ITabelas';

/* COMPONENTES */

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import TableCell from '@mui/material/TableCell';
import { Box, Typography } from '@mui/material';

import TableHead from './TableHead';
import TableSkeleton from './LoadingSkeleton';
import Paper from '@mui/material/Paper';

/* STYLES */

import { styled, Theme } from '@mui/material/styles';
import padrao from '../../servicos/mui/Theme';
import Bananinha, { IBananinhaDelegate } from '../widgets/Bananinha';
import { isEmpty, isNull } from 'lodash';

const TableListaPaginada = (props:IPropsTableListaPaginada) =>
{
	const appContext = useAppContextoReact();

	const OptsController = new OptionsController();
	
	const [rows, setRows] = React.useState([]);
	const [tipoPagina, setTipoPagina] = React.useState<ETABLE|undefined>();
	const [order, setOrder] = React.useState<Order>(props.orderHeranca || 'asc');
	const [orderedRows, setOrderedRows] = React.useState(props.lista);
	const [orderBy, setOrderBy] = React.useState<ColumnTypes | undefined>(undefined);
	const [isLoading, setIsLoading] = React.useState<boolean>(true);
    const [page, setPage] = React.useState(0);
	const [dense, setDense] = React.useState(false);
	const [expanded, setExpanded] = React.useState<string | false>(false);
	const [bananinhaDelegate, setBananinhaDelegate] = React.useState<IBananinhaDelegate|undefined>(undefined);

	const [userRoleAdmin, setUserRolerAdmin] = React.useState<boolean|null|undefined>(null);

	const isAcao = userRoleAdmin ? true : !userRoleAdmin && props.tipo === ETABLE.PROGRAMAS || props.tipo === ETABLE.SERIES;
	
	React.useEffect(() =>
	{
		setUserRolerAdmin(appContext.permissao.administrador)
	},[appContext])
	
	React.useEffect(() =>
	{
		setOrder(props.orderHeranca)
		setOrderBy(props.orderByHeranca);
	},[props.orderHeranca, props.orderByHeranca])

	const sortData = (property:any, order:string) => 
	{
		const sortedData = [...rows].sort((a, b) => 
		{
			const comparison = a[property].localeCompare(b[property]);
			return order === 'asc' ? comparison : -comparison;
		});
		setOrderedRows(sortedData);
	};

	const handleRequestSort = (event: React.MouseEvent<unknown>, property: ColumnTypes) => 
	{
		
		if (orderBy === property && order === 'asc')
		{
			setOrder('desc');
			setOrderBy(property);
			// sortData(property,'desc');
			props.handleFilter && props.handleFilter(event, { titulo: property, order: 'desc'}, property);
		}
		else if (orderBy === property && order === 'desc')
		{
			setOrder('asc');
			setOrderBy(undefined);
			// setOrderedRows(rows);
			props.handleFilter && props.handleFilter(event, { titulo: property, order: 'asc'}, property);
		}
		else
		{
			setOrder('desc');
			setOrderBy(property);
			// sortData(property,'desc');
			props.handleFilter && props.handleFilter(event, { titulo: property, order: 'desc'}, property);
		}
	};

	const handleChangePage = (event: unknown, newPage: number, rowsPerPage?: number) => 
	{
		props.callback(rowsPerPage ? rowsPerPage : props.rowsPerPage, newPage + 1);
	};

	const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
		setExpanded(isExpanded ? panel : false);
	};

	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => 
	{
		setIsLoading(false);
		handleChangePage(undefined,0,parseInt(event.target.value, 10))
	};

	React.useEffect(() =>
	{
		setRows(props.lista);
		setIsLoading(false);
	},[props.lista, props.paginacao])

	React.useEffect(() =>
	{
		setTipoPagina(props.tipo);
	},[props.tipo])

    const theadColumns = props.setup.map((column) => [column.id,column.align]);

	const _handleKeyDown = (e) =>
    {
		if (e.key === 'Enter') 
        {
			if(e.target.value)
			{
				if(parseInt(e.target.value) <= props.paginacao.total_pages)
					handleChangePage(undefined,parseInt(e.target.value) - 1,undefined)
				else
					bananinhaDelegate?.abrir('Só existem as páginas de 1 até ' + props.paginacao.total_pages, "error");
			}
			else
				handleChangePage(undefined,0,undefined)
        }
    }

	return <>
		<Bananinha getDelegate={delegate => bananinhaDelegate ?? setBananinhaDelegate(delegate)}/>
		<StyledTableContainer id={'CCTableContainerListaPaginada'}>
		{
			<Table size="small" sx={{ minWidth: 'inherit', maxWidth: 'inherit', width: '100%' }} stickyHeader>
				<TableHead
					order={order}
					orderBy={orderBy}
					onRequestSort={handleRequestSort}
					rowCount={rows.length}
					setup={props.setup}
					action={isAcao ? props.action : null}
					tipo={props.tipo}
				/>
				<TableBody>
				{
					rows.map((row:any, keyRow:any) => 
					{
						return (
							<StyledTableRow hover tabIndex={-1} key={keyRow}>
							{
								theadColumns.map((indice,key) =>
									<React.Fragment key={keyRow+'-'+key}>
									{
										indice[0] == 'dataCadastro' || indice[0] == 'dataAlteracao' ?
											<StyledTableCell key={keyRow+'-'+key} align="center" sx={{ textAlign: indice[1] || 'center' }}>{dateCoverter(row[indice[0]])}</StyledTableCell>
										: indice[0] == 'tipoSerie' ?
											<StyledTableCell key={keyRow+'-'+key} align="center" sx={{ textAlign: indice[1] || 'center' }}>
												{OptsController.nomeSerie(row[indice[0]]) as unknown as string}
											</StyledTableCell>
										: indice[0] == 'classificacaoEtaria' ?
											<StyledTableCell key={keyRow+'-'+key} align="center" sx={{ textAlign: indice[1] || 'center' }}>
												{OptsController.nomeClassificacaoEtaria(row[indice[0]]) as unknown as string}
											</StyledTableCell>
										: indice[0] == 'tipoPrograma' ?
											<StyledTableCell key={keyRow+'-'+key} align="center" sx={{ textAlign: indice[1] || 'center' }}>
												{OptsController.nomeTipoPrograma(row[indice[0]]) as unknown as string}
											</StyledTableCell>
										: indice[0] == 'tipoMidia' ?
											<StyledTableCell key={keyRow+'-'+key} align="center" sx={{ 
												textAlign: indice[1] || 'center', 
												...(tipoPagina === ETABLE.PROGRAMAS && indice[0] === 'tipoMidia' ? { minWidth: '105px' } : {})
												}}
											>
												{OptsController.nomeTipoMidia(row[indice[0]]) as unknown as string}
											</StyledTableCell>												
										: indice[0] == 'serie.titulo' ?
											<StyledTableCell key={keyRow+'-'+key} align="center" sx={{ textAlign: indice[1] || 'center' }}>
												{ (row["serie"] ? row["serie"].titulo : "") }
											</StyledTableCell>
										:
											<StyledTableCell
												key={keyRow+'-'+key}
												align="center"
												sx={{
													textAlign: indice[1] || 'center',
													wordWrap: 'break-word',
													...(tipoPagina === ETABLE.PROGRAMAS && indice[0] === 'titulo' ? { maxWidth: '150px' } : {})
												}}
											>
												{row[indice[0]]}
											</StyledTableCell>
									}
									</React.Fragment>
								)
							}
							{
								isAcao ?
									props.action?.map((itemAction:any,keyAction:any) =>
										<StyledTableCell key={keyAction+'_'+keyRow} align="center" sx={{ padding: '6px 4px', textAlign: 'center' }}>
											{itemAction.componentFunction(row)}
										</StyledTableCell>
									) : ''
							}
							</StyledTableRow>
						);
					})
				}
				</TableBody>
			</Table>
		}
		</StyledTableContainer>
		{
			(!isLoading && props.rowsPerPage && props.paginacao && props.tipo !== ETABLE.USER) &&
			<>
				<StyledDivPagination>
					<TablePagination
						rowsPerPageOptions={props.rowsPerPageOptions ? props.rowsPerPageOptions : [5,10,20,50,100]}
						count={props.paginacao.total_items}
						rowsPerPage={props.rowsPerPage}
						page={(props.pageNumber - 1)}
						onPageChange={handleChangePage}
						onRowsPerPageChange={handleChangeRowsPerPage}
						component="div"
						showFirstButton
						showLastButton
						labelRowsPerPage="Itens por página"
						labelDisplayedRows={function defaultLabelDisplayedRows({ from, to, count }) { return `${from}–${to} de ${count !== -1 ? `${count} itens` : `mais de ${to} itens`}`; }}
					/>
					<Box className={'pageNavigateInputStyle'}>
						<Box className="fields">
							<Typography component='strong' variant={'bs'}><span>Ir para </span>página</Typography>
							<input onKeyDown={_handleKeyDown} defaultValue={props.paginacao.current_page} />
							<Typography component='strong' variant={'bs'}>de {props.paginacao.total_pages}</Typography>
						</Box>
					</Box>
				</StyledDivPagination>	
			</>
		}
	</>
}
export default TableListaPaginada;

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
	position: 'relative',
	maxHeight: '70vh',
	'@media screen and (max-height:800px)':
	{
		maxHeight: '65vh',
	},
	'@media screen and (max-height:720px)':
	{
		maxHeight: '56vh',
	},
	'@media screen and (max-height:560px)':
	{
		maxHeight: '50vh',
	},
	'@media screen and (max-height:500px)':
	{
		maxHeight: '45vh',
	}
}));

const StyledDivPagination = styled('div')(({ theme }) => ({
	display: 'flex',
	flexFlow: 'row nowrap',
	justifyContent: 'space-between',
	alignItems: 'center',
	overflow: 'none',
	position: 'relative',
	
	".MuiTablePagination-spacer": { display: "none" },

	'& .MuiTablePagination-root': {overflow: 'none'},
	
	'& .MuiTablePagination-toolbar':
	{
		'& .MuiSelect-select':
		{
			border: '1px solid rgba(0,0,0,0.1)',
		}
	},

	".pageNavigateInputStyle": 
	{
		"& .fields":
		{
			paddingRight: 20,
			display: 'flex',
			flexFlow: 'row nowrap',
			justifyContent: 'flex-start',
			alignItems: 'center',
		},
		
		'& strong':
		{
			fontWeight: 400,
			textTransform: 'none',
			fontSize: '0.86rem'
		},
		'& input':
		{
			width: '36px',
			height: '30px',
			display: 'inline-flex',
			justifyContent: 'center',
			alignItems: 'center',
			border: '1px solid #CDCDCD',
			padding: '0 5px 0 2px',
			margin: '0 5px',
			textAlign: 'center',
			fontSize: '0.86rem'

		},
		
		'@media screen and (max-width: 800px)':
		{
			'& span':
			{
				display: 'block'
			}
		}
	},

	[theme.breakpoints.down('md')]: 
	{
		'& .MuiTablePagination-toolbar': {paddingLeft: 0},

		'& .pageNavigateInputStyle': 
		{
			'.fields': {paddingRight: 0},

			'strong:nth-of-type(1)': {textTransform: 'capitalize'},
			'span': {display: 'none'}
		}
	},
	[theme.breakpoints.down('sm')]: 
	{
		display: 'block',

		'& .MuiTablePagination-root': {display: 'block'},

		'& .MuiTablePagination-toolbar': {
			display: 'block',
			overflow: 'hidden',
			paddingTop: 10,
			verticalAlign: 'middle',

			'.MuiTablePagination-selectLabel': {float: 'left', display: 'inline-flex', verticalAlign: 'middle', paddingTop: 5},
			'.MuiTablePagination-select': {float: 'left', display: 'inline-flex', verticalAlign: 'middle'},
			'.MuiTablePagination-displayedRows': {float: 'right', display: 'inline-flex', verticalAlign: 'middle', paddingTop: 5},
			'.MuiTablePagination-actions': {clear: 'both', marginLeft: 0, position: 'relative', left: -10, paddingTop: 10}
		},

		'& .pageNavigateInputStyle': 
		{
			position: 'absolute',
			right: 0,
			bottom: 0,
		}
	}
}));

const StyledTableCell = styled(TableCell)(({}) => ({
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	'&:nth-of-type(odd)': {
		backgroundColor: padrao.palette.grey[50] // appTema.palette.action.active,
	},
	// hide last border
	'&:last-child td, &:last-child th': {
		border: 0,
	},
 }));
